export const handleTouchStart = (e, touchStartX) => {
  if (e && e.touches && e.touches[0]) {
    touchStartX.current = e.touches[0].clientX;
  }
};
